import { Controller } from "@hotwired/stimulus"

// While a drawn_story voiceover is generating, poll the style page and swap in the fresh
// voiceover panel — so "⏳ Generating…" flips to "✓ Ready" (or "✗ Failed") without a manual
// refresh. Pure client-side (no channel): it re-fetches THIS page, extracts the fresh
// #dst-voiceover-panel, and stops once the status is no longer "generating".
export default class extends Controller {
  static values = { status: String, interval: { type: Number, default: 5000 } }

  connect() {
    if (this.statusValue === "generating") this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  stopPolling() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }

  async poll() {
    let html
    try {
      const res = await fetch(window.location.href, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      if (!res.ok) return
      html = await res.text()
    } catch (_e) {
      return // transient network error — keep polling
    }

    const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("#dst-voiceover-panel")
    if (!fresh) return

    this.element.innerHTML = fresh.innerHTML
    if (fresh.getAttribute("data-voiceover-status-status-value") !== "generating") this.stopPolling()
  }
}
